import RugDetailModule from './RugDetailModule'
export default RugDetailModule
